import { render } from "./PasswordRequestView.vue?vue&type=template&id=0b638195&scoped=true&ts=true"
import script from "./PasswordRequestView.vue?vue&type=script&lang=ts"
export * from "./PasswordRequestView.vue?vue&type=script&lang=ts"

import "./LoginView.scss?vue&type=style&index=0&id=0b638195&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b638195"]])

export default __exports__